import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import styles from './PrepStatus.module.scss';

/** 首节预览出字前的准备步骤（只做提示，真实进度以正文开始输出为准） */
export const PREP_PHASES = [
    {
        id: 'env',
        name: '准备写作环境',
        steps: ['加载学术写作规范与格式模板', '解析题目与大纲结构', '分配各章节篇幅与写作要点'],
    },
    {
        id: 'refs',
        name: '检索文献',
        steps: ['检索相关中英文文献', '筛选高相关文献并整理题录', '建立引用索引'],
    },
    {
        id: 'write',
        name: '撰写首节',
        steps: ['规划图表与段落结构', '正在撰写首节预览内容'],
    },
];

const STEPS = PREP_PHASES.flatMap((phase, phaseIndex) =>
    phase.steps.map((text) => ({ text, phaseIndex })),
);
const STEP_MS = 1500;

/**
 * 稿纸里的轻量等待提示：预览请求已经发出，等首个字到达前循环展示准备步骤与已等待时长。
 * resume 为 true 时表示正在接上一次未完成的预览（后端会补发已生成的内容）。
 */
export default function PrepStatus({ resume = false }) {
    const [elapsed, setElapsed] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => setElapsed((value) => value + 1), 1000);
        return () => clearInterval(timer);
    }, []);

    if (resume) {
        return (
            <div className={styles.ticker} role="status" aria-live="polite">
                <LoadingOutlined spin className={styles.spin} />
                <span className={styles.text}>正在接上未完成的预览，已生成的内容马上显示…</span>
                <span className={styles.elapsed}>{elapsed}s</span>
            </div>
        );
    }

    const stepIndex = Math.min(Math.floor((elapsed * 1000) / STEP_MS), STEPS.length - 1);
    const step = STEPS[stepIndex];
    const lastStep = stepIndex === STEPS.length - 1;

    return (
        <div className={styles.card} role="status" aria-live="polite">
            <div className={styles.head}>
                <LoadingOutlined spin className={styles.spin} />
                <span className={styles.title}>正在生成免费预览</span>
                <span className={styles.elapsed}>已等待 {elapsed}s</span>
            </div>
            <ol className={styles.phases}>
                {PREP_PHASES.map((phase, index) => {
                    const state =
                        index < step.phaseIndex
                            ? 'done'
                            : index === step.phaseIndex
                              ? 'active'
                              : 'todo';
                    return (
                        <li key={phase.id} className={styles.phase} data-state={state}>
                            {state === 'done' ? (
                                <CheckCircleFilled />
                            ) : (
                                <span className={styles.dot} />
                            )}
                            {phase.name}
                        </li>
                    );
                })}
            </ol>
            <div className={styles.step}>
                {step.text}
                {lastStep ? '，内容会在这里逐字出现' : '…'}
            </div>
        </div>
    );
}
